import {z} from 'zod';

/**
 * Sort order for a field.
 */
export const SortOrder = {
	ASCENDING: 'asc',
	DESCENDING: 'desc',
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];

/**
 * Sort schema.
 */
export const SortSchema = z.object({
	field: z.string(),
	order: z.enum([SortOrder.ASCENDING, SortOrder.DESCENDING]),
});
